var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bus-window",on:{"click":function($event){return _vm.close()}}},[_vm._m(0),_c('div',{staticClass:"bus-window__frame"},[_c('div',{staticClass:"qr",domProps:{"innerHTML":_vm._s(_vm.qr)}})])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bus-window__header"},[_c('div',{staticClass:"tab-button close",attrs:{"data-translation-element":"close"}},[_vm._v("Close")])])
}]

export { render, staticRenderFns }